import { render, staticRenderFns } from "./ReporteMilDetalles.vue?vue&type=template&id=7b652022&"
import script from "./ReporteMilDetalles.vue?vue&type=script&lang=js&"
export * from "./ReporteMilDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports